<template>
    <svg xmlns="http://www.w3.org/2000/svg"
        :fill="svgFill" 
        viewBox="0 0 16 16" 
        class="size-4">
        <defs><clipPath id="_clipPath_5vibD6fwWeiMDQAyUzTUYTbd1t6bQ4BI"><rect width="16" height="16"/></clipPath></defs><g clip-path="url(#_clipPath_5vibD6fwWeiMDQAyUzTUYTbd1t6bQ4BI)">
        <path d=" M 2.001 12.287 C 2.021 12.821 2.461 13.248 3 13.248 C 3.541 13.248 3.981 12.819 3.999 12.283 C 4 12.272 4 3.762 4 3.75 C 4 3.198 3.552 2.75 3 2.75 C 2.448 2.75 2 3.198 2 3.75 C 2 3.763 2 12.274 2.001 12.287 Z " :fill="svgFill"/>
        <path d=" M 6.25 3 C 5.836 3 5.5 3.336 5.5 3.75 C 5.5 4.164 5.836 4.5 6.25 4.5 L 13.25 4.5 C 13.664 4.5 14 4.164 14 3.75 C 14 3.336 13.664 3 13.25 3 L 6.25 3 Z " :fill="svgFill"/>
        <path d=" M 6.25 7.25 C 5.836 7.25 5.5 7.586 5.5 8 C 5.5 8.414 5.836 8.75 6.25 8.75 L 13.25 8.75 C 13.664 8.75 14 8.414 14 8 C 14 7.586 13.664 7.25 13.25 7.25 L 6.25 7.25 Z " :fill="svgFill"/>
        <path d=" M 6.25 11.5 C 5.836 11.5 5.5 11.836 5.5 12.25 C 5.5 12.664 5.836 13 6.25 13 L 13.25 13 C 13.664 13 14 12.664 14 12.25 C 14 11.836 13.664 11.5 13.25 11.5 L 6.25 11.5 Z " :fill="svgFill"/></g>
    </svg>
</template>

<script setup>
import { defineProps, computed } from 'vue';
const props = defineProps(['fill'])

const svgFill = computed(() => {
    return props.fill ? props.fill : 'black'
})
</script>